/**
 * This page is used by the admin app as part of a flow that allows
 * admin users to log into their patient's client side app. The admin
 * app assumes that this page exists at `/admin-impersonate`.
 *
 * The hardcoded link to this page is stored in
 * Shared/RepeatMD.Shared/Commands/Admin/Users/RequestMagicLinkForPlatformUserInPatientAppCommand.cs
 */

import { type LoaderFunction, redirect } from "react-router-dom";

import { postAuthExchangeAdminToken } from "api/methods";
import { queryClient } from "pages/Root";
import Services from "services/Services";

export const adminImpersonateLoader: LoaderFunction = async ({ request }) => {
  // Never refetch the previous patient's data while exchanging identities.
  await queryClient.cancelQueries();
  await Services.auth.clearAll();

  const authToken = new URL(request.url).searchParams.get("authToken");
  if (!authToken) {
    return redirect("/signin");
  }

  const { token } = await postAuthExchangeAdminToken({ authToken });

  if (token) {
    await Services.auth.setImpersonation(token);
    queryClient.clear();

    return redirect("/home");
  } else {
    return redirect("/signin");
  }
};
